
const translation = {
  nav_used_pallets: "طبليات مستعملة",
  nav_new_pallets: "طبليات جديدة",
  nav_services: "الخدمات",
  nav_about: "من نحن",
  nav_faq: "الأسئلة الشائعة",
  nav_contact: "اتصل بنا",
  nav_get_quote: "طلب عرض سعر",

  hero_location: "أنتويرب، بلجيكا",
  hero_title_line1: "طبليات يورو",
  hero_title_line2: "عالية الجودة",
  hero_subtitle: "مورد موثوق لطبليات الدرجة A وB المستعملة والطبليات الخشبية الجديدة. فحص جودة. توصيل سريع في جميع أنحاء بلجيكا.",
  hero_cta_quote: "طلب عرض سعر",
  hero_cta_products: "عرض المنتجات",

  stat_years: "سنوات خبرة",
  stat_pallets: "طبلية تم توصيلها",
  stat_grades: "درجات المنتج",
  stat_quality: "فحص جودة",

  gallery_label: "جودة يمكنك رؤيتها",
  gallery_title: "مجموعة طبلياتنا",
  gallery_grade_a: "الدرجة A المميزة",
  gallery_grade_b: "الدرجة B الاقتصادية",
  gallery_new: "طبليات جديدة",
  gallery_custom: "طلبات مخصصة",

  how_label: "عملية بسيطة",
  how_title: "كيف يعمل",
  how_subtitle: "من التصفح إلى التوصيل، نجعل طلب الطبليات سريعاً وسهلاً.",
  how_step1_title: "تصفح واختر",
  how_step1_desc: "استكشف مجموعتنا من طبليات الدرجة A وB والجديدة. اطلع على المواصفات التفصيلية والصور.",
  how_step2_title: "طلب عرض سعر / طلب",
  how_step2_desc: "أرسل طلب عرض سعر أو قدم طلباً مباشراً عبر الإنترنت. سنؤكد خلال 24 ساعة.",
  how_step3_title: "توصيل سريع",
  how_step3_desc: "استلم طبلياتك بسرعة في جميع أنحاء بلجيكا وأوروبا. جميع الطلبات تخضع لفحص الجودة قبل الشحن.",

  used_label: "طبليات مستعملة عالية الجودة",
  used_title: "طبليات يورو المستعملة",
  used_subtitle: "اختر بين الدرجة A المميزة أو الدرجة B الاقتصادية. جميعها مفحوصة وجاهزة للاستخدام الفوري.",

  new_label: "طبليات جديدة تماماً",
  new_title: "طبليات خشبية جديدة",
  new_subtitle: "طبليات معتمدة ISPM15، جاهزة للتصدير، مصنوعة وفق أعلى المعايير. أحجام مخصصة متاحة.",

  product_quick_specs: "مواصفات سريعة",
  product_dimensions: "الأبعاد",
  product_load: "سعة التحميل",
  product_wood: "نوع الخشب",
  product_order_now: "اطلب الآن",
  product_view_details: "عرض التفاصيل",
  product_view_angles: "زوايا العرض والتفاصيل",
  product_tech_specs: "المواصفات التقنية",
  product_key_features: "الميزات الرئيسية",
  product_request_quote: "طلب عرض سعر لهذا المنتج",
  product_call_us: "اتصل بنا",

  calc_current_price: "السعر الحالي",
  calc_volume_hint: "أسعار الكميات متاحة – اطلب أكثر ووفّر أكثر!",
  calc_total_price: "السعر الإجمالي",
  calc_price_per: "السعر لكل طبلية",
  calc_quantity: "الكمية",
  calc_pallets: "طبليات",
  calc_order_now: "اطلب",
  calc_current_selection: "الاختيار الحالي",
  calc_pieces: "قطعة",
  calc_per_pallet: "لكل طبلية",
  calc_calculate: "احسب طلبك",
  calc_payment_methods: "طرق الدفع المتاحة",
  calc_volume_pricing: "أسعار الكميات",
  calc_bulk_discount: "خصم الكمية مطبّق",
  calc_min_order: "الحد الأدنى للطلب: 10 طبليات",
  calc_payment_methods_label: "طرق الدفع:",
  calc_total: "الإجمالي:",
  calc_select_qty: "اختر الكمية وطريقة الدفع",
  calc_total_price_label: "السعر الإجمالي",

  services_label: "ما نقدمه",
  services_title: "خدماتنا",
  services_subtitle: "من الفرز إلى التوصيل، نقدم حلول طبليات متكاملة لعملك.",
  service1_title: "فرز وتصنيف الطبليات",
  service1_desc: "فحص يدوي متخصص وتصنيف لكل طبلية لضمان حصولك على الجودة التي طلبتها.",
  service2_title: "التوريد بالجملة",
  service2_desc: "طلبات الكميات الكبيرة مرحب بها. أسعار تنافسية للمشتريات بالجملة.",
  service3_title: "طلبات مخصصة",
  service3_desc: "تحتاج إلى أحجام غير قياسية؟ نصنع طبليات خشبية مخصصة حسب متطلباتك.",
  service4_title: "توصيل سريع",
  service4_desc: "توصيل موثوق في جميع أنحاء بلجيكا وأوروبا.",

  quality_label: "معاييرنا",
  quality_title: "نظام درجات الجودة",
  quality_subtitle: "كل طبلية نوردها تخضع لفحص دقيق وتصنيف وفق المعايير الأوروبية الصارمة.",
  grade_a_label: "الدرجة المميزة",
  grade_b_label: "الدرجة القياسية",
  grade_new_label: "جديدة تماماً",

  about_label: "من نحن",
  about_title: "شريك الطبليات الموثوق في أنتويرب",
  about_p1: "PEL Partner Company هي مورد متخصص لطبليات اليورو مقره في أنتويرب، بلجيكا. نزود الشركات في جميع أنحاء بلجيكا وأوروبا بطبليات عالية الجودة.",
  about_p2: "سواء كنت تحتاج إلى طبليات الدرجة A المميزة أو الدرجة B الاقتصادية أو طبليات جديدة للتصدير — لدينا الحل المناسب بالسعر المناسب.",
  about_location: "أنتويرب، بلجيكا",
  about_quality: "كل طبلية مفحوصة",
  about_delivery: "سريع في جميع أنحاء بلجيكا",
  about_support: "الاثنين–الجمعة 8:00–18:00",
  about_years: "سنوات في العمل",
  about_supplied: "طبلية تم توريدها",

  videos_label: "شاهده في العمل",
  videos_title: "عملياتنا",
  videos_subtitle: "شاهد كيف نفرز ونفحص ونجهز الطبليات لتلبية أعلى معايير الجودة.",
  tab_sorting: "عملية الفرز",
  tab_quality: "فحص الجودة",
  tab_delivery: "التوصيل",
  video_sorting_title: "الفرز والفحص اليدوي",
  video_sorting_desc: "كل طبلية تخضع للفحص اليدوي للجودة",
  video_strict: "فحص صارم",
  video_strict_desc: "كل طبلية تخضع للفحص اليدوي للتحقق من السلامة الهيكلية والامتثال لمعايير EPAL.",
  video_sorted: "مصنفة حسب الدرجة",
  video_sorted_desc: "يتم فرز الطبليات بعناية إلى الدرجة A وB والجديدة.",
  video_reliable: "توصيل موثوق",
  video_reliable_desc: "نوصل في جميع أنحاء أنتويرب وبلجيكا بأوقات تسليم سريعة.",

  why_title: "لماذا تختار PEL Partner؟",
  why1_title: "جودة معتمدة",
  why1_desc: "طبليات معتمدة EPAL، كل دفعة مفحوصة وفق المعايير الأوروبية.",
  why2_title: "أسعار تنافسية",
  why2_desc: "أفضل الأسعار في أنتويرب للطبليات من الدرجة A وB والجديدة.",
  why3_title: "تسليم سريع",
  why3_desc: "معالجة سريعة للطلبات والتوصيل في جميع أنحاء بلجيكا.",
  why4_title: "شريك موثوق",
  why4_desc: "علاقات طويلة الأمد مبنية على الثقة والاتساق والجودة.",

  delivery_label: "نوصل في جميع أنحاء بلجيكا",
  delivery_title: "مناطق خدمتنا",
  delivery_subtitle: "توصيل سريع وموثوق إلى المدن والمناطق الرئيسية في جميع أنحاء بلجيكا وأوروبا.",

  faq_label: "أسئلة شائعة",
  faq_title: "الأسئلة المتكررة",
  faq_subtitle: "اعثر على إجابات للأسئلة الأكثر شيوعاً حول طبلياتنا وخدماتنا وعملية الطلب.",
  faq_q1: "ما درجات الطبليات التي تقدمونها؟",
  faq_a1: "نقدم ثلاث درجات: الدرجة A (طبليات مستعملة مميزة في حالة ممتازة)، الدرجة B (طبليات مستعملة اقتصادية مع تآكل طفيف)، وطبليات خشبية جديدة (جديدة تماماً، معتمدة ISPM15 للتصدير).",
  faq_q2: "ما هي الحد الأدنى لكمية الطلب؟",
  faq_a2: "نستوعب طلبات بجميع الأحجام، من الكميات الصغيرة إلى الطلبات الكبيرة. اتصل بنا لمناقشة متطلباتك.",
  faq_q3: "ما المناطق التي توصلون إليها؟",
  faq_a3: "نوصل في جميع أنحاء بلجيكا، بما في ذلك أنتويرب وبروكسل وغنت وبروج وليج. كما نخدم عملاء في جميع أنحاء أوروبا.",
  faq_q4: "ما هي مواعيد التسليم لديكم؟",
  faq_a4: "طبليات الدرجة A وB المستعملة متوفرة عادةً في المخزون وجاهزة للتسليم الفوري. قد تستغرق الطبليات الجديدة 1-2 أسبوع.",
  faq_q5: "هل طبلياتكم معتمدة EPAL؟",
  faq_a5: "نعم، طبليات الدرجة A لدينا معتمدة ومختومة بـ EPAL. جميع الطبليات الجديدة معالجة حرارياً وفق ISPM15.",
  faq_q6: "هل تقدمون أحجاماً مخصصة للطبليات؟",
  faq_a6: "نعم، يمكننا تصنيع طبليات خشبية جديدة بأبعاد مخصصة. الحجم القياسي EUR/EPAL هو 1200 × 800 مم.",
  faq_q7: "كيف تضمنون جودة الطبليات؟",
  faq_a7: "كل طبلية يفحصها موظفونا المدربون يدوياً. نتحقق من السلامة الهيكلية وحالة الألواح والامتثال لمعايير EPAL.",
  faq_q8: "ما طرق الدفع التي تقبلونها؟",
  faq_a8: "نقبل التحويلات البنكية وبطاقات الائتمان ويمكننا ترتيب شروط دفع للعملاء المعتمدين.",

  contact_label: "تواصل معنا",
  contact_title: "ابق على تواصل",
  contact_info_title: "معلومات الاتصال",
  contact_phone_label: "الهاتف",
  contact_email_label: "البريد الإلكتروني",
  contact_location_label: "الموقع",
  contact_hours_label: "ساعات العمل",
  contact_hours_val: "الاثنين – الجمعة: 8:00 – 18:00",
  contact_call_now: "اتصل الآن",
  contact_email_us: "راسلنا",
  contact_quote_title: "طلب عرض سعر",
  form_name: "الاسم",
  form_phone: "الهاتف",
  form_email: "البريد الإلكتروني",
  form_product: "المنتج",
  form_product_placeholder: "اختر منتجاً...",
  form_product_a: "طبليات يورو مستعملة — الدرجة A",
  form_product_b: "طبليات يورو مستعملة — الدرجة B",
  form_product_new: "طبليات خشبية جديدة",
  form_product_mixed: "طلب مختلط",
  form_message: "الرسالة",
  form_message_placeholder: "أخبرنا عن متطلباتك، الكمية المطلوبة...",
  form_send: "إرسال الطلب",
  form_sending: "جارٍ الإرسال...",
  form_success_title: "تم إرسال الرسالة!",
  form_success_desc: "سنرد عليك في أقرب وقت ممكن.",
  form_send_another: "إرسال رسالة أخرى",
  form_error: "حدث خطأ ما. يرجى المحاولة مرة أخرى.",

  order_title: "تقديم طلبك",
  order_subtitle: "أدخل بياناتك وسنؤكد طلبك خلال 24 ساعة.",
  order_company: "اسم الشركة",
  order_company_ph: "اسم شركتك",
  order_contact: "اسم جهة الاتصال",
  order_contact_ph: "اسمك الكامل",
  order_quantity: "الكمية",
  order_quantity_ph: "عدد الطبليات",
  order_address: "عنوان التوصيل",
  order_address_ph: "الشارع، المدينة، الرمز البريدي",
  order_date: "تاريخ التوصيل المفضل",
  order_notes: "ملاحظات إضافية",
  order_notes_ph: "أي متطلبات خاصة أو أسئلة...",
  order_cancel: "إلغاء",
  order_review: "مراجعة الطلب",
  order_summary_title: "ملخص الطلب",
  order_summary_subtitle: "يرجى مراجعة تفاصيل طلبك قبل الإرسال.",
  order_company_info: "معلومات الشركة",
  order_company_name_label: "اسم الشركة",
  order_contact_label: "الشخص المسؤول",
  order_email_label: "البريد الإلكتروني",
  order_phone_label: "الهاتف",
  order_details: "تفاصيل الطلب",
  order_product_label: "المنتج",
  order_qty_label: "الكمية",
  order_qty_unit: "طبليات",
  order_address_label: "عنوان التوصيل",
  order_date_label: "التاريخ المفضل",
  order_notes_label: "ملاحظات إضافية",
  order_next_steps: "الخطوات التالية:",
  order_next_steps_desc: "بعد إرسال طلبك، سيراجعه فريقنا ويتصل بك خلال 24 ساعة لتأكيد التسعير والتوافر وتفاصيل التوصيل.",
  order_edit: "تعديل الطلب",
  order_confirm: "تأكيد وإرسال",
  order_submitting: "جارٍ إرسال طلبك...",
  order_submitting_desc: "يرجى الانتظار لحظة.",
  order_success_title: "تم إرسال الطلب بنجاح!",
  order_ref_label: "رقم المرجع",
  order_success_desc: "شكراً لطلبك! سنراجع طلبك ونتصل بك خلال 24 ساعة لتأكيد التسعير والتوافر وتفاصيل التوصيل.",
  order_close: "إغلاق",
  order_error: "حدث خطأ ما. يرجى المحاولة مرة أخرى.",

  footer_products: "المنتجات",
  footer_contact: "اتصل بنا",
  footer_copyright: "© 2025 PEL Partner Company. جميع الحقوق محفوظة.",
  footer_tagline: "أنتويرب، بلجيكا — مورد طبليات يورو",
  footer_desc: "موردك الموثوق لطبليات اليورو في أنتويرب، بلجيكا. طبليات الدرجة A وB والجديدة — جودة مضمونة.",

  compare_label: "مقارنة",
  compare_title: "قارن بين درجات طبلياتنا",
  compare_subtitle: "لست متأكداً من الدرجة المناسبة لك؟ قارن الخيارات الثلاثة دفعة واحدة.",
  compare_feature: "الميزة",
  compare_grade_a: "الدرجة A",
  compare_grade_b: "الدرجة B",
  compare_new: "طبليات جديدة",
  compare_condition: "الحالة",
  compare_condition_a: "ممتازة — تآكل طفيف",
  compare_condition_b: "جيدة — تآكل مظهري بسيط",
  compare_condition_new: "جديدة تماماً — غير مستخدمة",
  compare_certification: "الاعتماد",
  compare_certification_a: "معتمدة EPAL",
  compare_certification_b: "مفحوصة الجودة",
  compare_certification_new: "معتمدة ISPM15",
  compare_load: "سعة التحميل",
  compare_load_a: "حتى 1500 كغ",
  compare_load_b: "حتى 1000 كغ",
  compare_load_new: "حتى 2000 كغ",
  compare_export: "جاهزة للتصدير",
  compare_export_a: "الاتحاد الأوروبي فقط",
  compare_export_b: "الاتحاد الأوروبي فقط",
  compare_export_new: "عالمياً",
  compare_custom: "أحجام مخصصة",
  compare_custom_a: "لا",
  compare_custom_b: "لا",
  compare_custom_new: "نعم",
  compare_availability: "التوفر",
  compare_availability_a: "متوفر في المخزون",
  compare_availability_b: "متوفر في المخزون",
  compare_availability_new: "حسب الطلب",
  compare_best_for: "الأنسب لـ",
  compare_best_for_a: "الغذاء والبضائع الحساسة",
  compare_best_for_b: "التخزين العام",
  compare_best_for_new: "التصدير والشحن الدولي",
  compare_starting_price: "السعر الابتدائي",
  compare_cta: "اطلب الآن",
  compare_yes: "نعم",
  compare_no: "لا",
};

export default translation;
